// extracted by mini-css-extract-plugin
export default {"container":"adminTableOperation_container__gSugv"};